export { Trophy1 } from "./Trophy1";
